import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs/internal/Subscription';
import { CimaCore } from 'core/services';
import { XmStore, XmStoreUtil } from 'services/store';
import { User } from 'store/user/models';
import { CmsUserRoles } from 'store/cms/models/user-roles';
import { Util } from 'services/util';


@Component({
    selector: 'xm-user-role-component',
    styleUrls: ['./user-roles.scss'],
    templateUrl: './user-roles.html',
    standalone: false
})
export class XmUserRoleComponent implements OnInit {
    public pageData:  CmsUserRoles;
    public user: User;
    public userRole: string;
    public isBusinessUser: boolean;

    private cimaCore: CimaCore;
    private xmStore: XmStore;
    private subscriptions: Subscription[] = [];

    constructor(cimaCore: CimaCore, xmStore: XmStore) {
        Object.assign(this, { cimaCore, xmStore });
    }

    public ngOnInit(): void {
        this.isBusinessUser = this.cimaCore.isBusinessUser;

        this.subscriptions.push(XmStoreUtil.subscribe(this.xmStore.peek<CmsUserRoles>(CmsUserRoles), (result: CmsUserRoles) => {
            this.pageData = result;
        }));

        this.subscriptions.push(this.xmStore.peek<User>(User).subscribe((user: User) => {
            this.user = user;
            this.userRole = Util.createPascalCase(user.account?.role);
        }));
    }
}
